import { RootState } from 'core/reducers'

export const getUsersSingleDataSelector = (state: RootState) => state.users.single.data
